import { render, staticRenderFns } from "./OrderServiceList.vue?vue&type=template&id=221b10b8&scoped=true"
import script from "./OrderServiceList.vue?vue&type=script&lang=js"
export * from "./OrderServiceList.vue?vue&type=script&lang=js"
import style0 from "./OrderServiceList.vue?vue&type=style&index=0&id=221b10b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221b10b8",
  null
  
)

export default component.exports